import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@systemeio/components';
import { Cents, CurrencyEnum } from '@systemeio/types';
import { centsToUnits } from '@systemeio/util';
import { useAffiliateDashboardVendors } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-vendors';
import { AffiliateDashboardFilterInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { VendorId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-vendors-interface';
import React, { useEffect, useMemo, useState } from 'react';
import { FormSelect } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
interface AffiliateVendorSelectorProps {
  selectedVendor?: VendorId;
  setFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardVendorSelector = t0 => {
  const $ = _c(18);
  const {
    selectedVendor,
    setFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const [shouldFetch, setShouldFetch] = useState(false);
  let t1;
  let t2;
  if ($[0] !== selectedVendor) {
    t1 = () => {
      if (selectedVendor) {
        setShouldFetch(true);
      }
    };
    t2 = [selectedVendor];
    $[0] = selectedVendor;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const {
    data: vendors
  } = useAffiliateDashboardVendors(shouldFetch);
  user?.dashboardLocale;
  let t3;
  if ($[3] !== intlLocale || $[4] !== t || $[5] !== user?.dashboardLocale || $[6] !== vendors) {
    const listFormat = new Intl.ListFormat(intlLocale, {
      type: "unit",
      style: "short"
    });
    const formatSums = sums => listFormat.format((Object.keys(sums) as CurrencyEnum[]).map(cur => currencyFormat(centsToUnits(sums[cur]), cur, user?.dashboardLocale)));
    t3 = vendors?.map(t4 => {
      const {
        vendor,
        sales,
        paid,
        pending
      } = t4;
      return {
        caption: vendor.affiliateProgramBrandName,
        customCaption: <span className="flex items-start gap-2.5"><Avatar size="lg" alt={vendor.affiliateProgramBrandName} src={vendor.avatar} displayName={vendor.affiliateProgramBrandName} /><span className="flex min-w-0 flex-col gap-1"><span className="text-text-primary line-clamp-2 font-medium">{vendor.affiliateProgramBrandName}</span><span className="text-text-tertiary text-sm">{t("dashboard.affiliate_dashboard.vendor_sums", {
                sales: formatSums(sales),
                paid: formatSums(paid),
                pending: formatSums(pending)
              })}</span></span></span>,
        id: vendor.id
      };
    });
    $[3] = intlLocale;
    $[4] = t;
    $[5] = user?.dashboardLocale;
    $[6] = vendors;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const vendorsData = t3;
  let t4;
  if ($[8] !== setFilter) {
    t4 = vendorId => setFilter(prev => ({
      ...prev,
      vendorId
    }));
    $[8] = setFilter;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setShouldFetch(true);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.affiliate_dashboard.vendor");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== selectedVendor || $[14] !== t4 || $[15] !== t6 || $[16] !== vendorsData) {
    t7 = <FormSelect data={vendorsData} onChange={t4} onOpen={t5} placeholder={t6} value={selectedVendor} />;
    $[13] = selectedVendor;
    $[14] = t4;
    $[15] = t6;
    $[16] = vendorsData;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default AffiliateDashboardVendorSelector;